import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { render } from "@testing-library/react";
import { theme } from "lib/consolidate-theme";
import { GlobalStyles } from "@refract-ui/core";
import configureStore from "redux-mock-store";
import createSagaMiddleware from "redux-saga";
import * as router from "next/router";
import * as rffarray from "react-final-form-arrays";
import * as cc from "hooks/use-customer-client";
import * as au from "hooks/use-admin-user";
import { QueryProvider } from "./Query";

const TestContext = React.createContext({
  reload: () => {},
  handleSubmit: () => {},
  loading: false,
  data: {},
});

export { TestContext };

const TestWrapper = ({ query, children }) => {
  const sagaMiddleware = createSagaMiddleware();
  const mockStore = configureStore([sagaMiddleware]);
  mockStore.sagaRunning = true;
  const store = mockStore({});
  return (
    <TestContext.Provider value={query}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <QueryProvider
            store={store}
            clients={{}}
            reducerKey="queryApi"
            defaultUserType="customer"
          >
            <GlobalStyles />
            {children}
          </QueryProvider>
        </Provider>
      </ThemeProvider>
    </TestContext.Provider>
  );
};

TestWrapper.propTypes = {
  query: PropTypes.object.isRequired,
  children: PropTypes.element,
};

TestWrapper.defaultProps = {
  children: undefined,
};

const customRender = (ui, q, options) =>
  render(ui, {
    wrapper: (props) => <TestWrapper {...props} query={q} />,
    ...options,
  });

export default customRender;

export const blankQueryProps = {
  activeFlag: true,
  reload: () => {},
  handleSubmit: () => {},
  loading: false,
  data: {},
};

export const createDeeplyNestedProxy = () => {
  let obj = {};
  const handler = {
    get() {
      return new Proxy({}, handler);
    },
  };
  obj = new Proxy(obj, handler);
  return obj;
};

export const createMockTestBed = () => {
  Object.defineProperty(cc, "default", { // eslint-disable-line
    value: jest.fn(() => ({
      request: () =>
        new Promise(() => {
          setTimeout(() => {
            resolve("req"); // eslint-disable-line
          }, 0);
        }),
      validateToken: () =>
        new Promise(() => {
          setTimeout(() => {
            resolve("foo"); // eslint-disable-line
          }, 0);
        }),
    })),
    configurable: true,
    writable: true,
  });
  Object.defineProperty(au, "default", { // eslint-disable-line
    value: jest.fn(() => ({
      id: "test",
    })),
    configurable: true,
    writable: true,
  });
  router.useRouter = jest.fn(); // eslint-disable-line
  router.useRouter.mockImplementation(() => ({
    asPath: "",
    replace: () => {},
    query: "",
    push: () => {},
  }));
  rffarray.FieldArray = jest.fn(); // eslint-disable-line
  rffarray.FieldArray.mockImplementation(() => {
    return <div />;
  });
};
